export default __webpack_public_path__ + "static/media/Services - Licence work.b7c2f1f0.jpg";